/* jshint esversion: 6, -W097 */
/* globals require */
(function (angular) {
    'use strict';
    angular
        .module('enervee')
        .directive('cart', cartDirective);

    const constants = require('@utils/_constants');
    /*
     Creates checkout cart
     <cart></cart>

     */

    function cartDirective() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                productDetailData: '='
            },
            bindToController: true,
            controllerAs: 'vm',
            controller: cartController,
            template: require('@app/shared/cart/cartView.html'),
        };
    }

    cartController.$inject = [
        '$log',
        '$sce',
        '$state',
        '$filter',
        '$timeout',
        '$location',
        '$rootScope',
        'AccountAuthService',
        'AnalyticsService',
        'CartService',
        'CartAnalyticsService',
        'CmsContentService',
        'EnerveeCheckoutService',
        'EnerveeRebateService',
        'UtilService',
        'RebatesService',
        'ModalQueueService',
        'CookiesService'
    ];
    function cartController(
        $log,
        $sce,
        $state,
        $filter,
        $timeout,
        $location,
        $rootScope,
        AccountAuthService,
        AnalyticsService,
        CartService,
        CartAnalyticsService,
        CmsContentService,
        EnerveeCheckoutService,
        EnerveeRebateService,
        UtilService,
        RebatesService,
        ModalQueueService,
        CookiesService
    ) {
        this.$onInit = function () {
            const vm = this;
            vm.cartOpen = false;
            vm.cartTotalPrice = 0;
            vm.finalizedCartTotalPrice = 0;
            vm.cartDetails = CartService.cartDetails;
            vm.cartItems = CartService.getItems();

            vm.isCheckoutEnabled = UtilService.isFeatureEnabled('checkout_enabled');
            vm.cartEnabled = vm.isCheckoutEnabled;
            vm.debugMode = UtilService.isFeatureEnabled('checkout_debug');

            vm.cartItemsWithRebates = [];
            vm.loadingVerification = false;
            vm.loadingBestRebates = false;
            vm.eligibleSubtitle = "";

            vm.cmsContext = {};

            vm.cartGetBestRebate = cartGetBestRebate;
            vm.redirectToCheckout = redirectToCheckout;
            vm.openApplicationForm = openApplicationForm;

            vm.fullEligibleForRebates = false;
            vm.redirectingToCheckout = false;

            CmsContentService.getMarketPlaceText('checkout:loading_rebates_text').then(function (text) {
                vm.loaderGetRebatesText = text;
            });

            vm.userIsAuthenticated = AccountAuthService.isAuthenticated;

            // buttons rendered in thank you section
            vm.next_best_action = UtilService.getSiteSetting('next_best_action');

            vm.cartView = {
                'total': true,
                'approved': false,
                'rejected': false,
                'norebates': false,
                'thankyou': false
            };

            /**
             * Cycle through various cart views
             * @param {String} viewKey the view to switch to
             */
            vm.switchCartView = function (viewKey) {
                if (vm.cartView.hasOwnProperty(viewKey)) {
                    for (var key in vm.cartView) {
                        vm.cartView[key] = (key === viewKey);
                    }
                }
            };

            /**
             * Cycle through various cart views to see which is currently active
             * @returns {string} current active view name
             */
            vm.getCurrentCartView = function () {
                for (var key in vm.cartView) {
                    if (vm.cartView[key]) {
                        return key;
                    }
                }
            };

            /**
             * Open the cart
             * @param {Boolean} resetView - should we reset the view to total?
             */
            vm.openCart = function (resetView) {
                vm.partnerCmsContext = {'partner': CartService.cartDetails.fulfillmentPartnerName};

                ModalQueueService.closePastModals(vm.closeCart);

                if (resetView) {
                    vm.switchCartView('total');
                }
                vm.cartOpen = true;
            };

            /**
             * Close the cart
             */
            vm.closeCart = function () {
                if (vm.getCurrentCartView() === 'thankyou') {
                    vm.switchCartView('total');
                }
                vm.cartOpen = false;
            };

            /**
             * Report when user closes cart
             */
            vm.closeCartClicked = function () {
                CartAnalyticsService.reportEvent('Cart Closed', {
                    location: 'cart',
                })
                vm.closeCart();
            };

            /**
             * Report when user closes cart
             */
            vm.backToCartButtonClicked = function () {
                CartAnalyticsService.reportEvent('Cart Viewed', {
                    location: 'cart',
                    status: vm.cartView.approved ? 'Verification Succeeded' : 'Verification Failed'
                });
            }

            /**
             * Show thank you confirmation after user returns from 3rd party purchase
             */
            var showThankYouView = function () {
                vm.switchCartView('thankyou');
                vm.openCart();
            };

            if (vm.isCheckoutEnabled && $location.search().hasOwnProperty('cart-thank-you')) {
                showThankYouView();
            }

            /**
             * Take users to the orders profile page.
             */
            vm.goToOrders = function () {
                vm.closeCart();
                $state.go('my-orders');
            };

            CartService.setCartOpenCallback(vm.openCart);
            CartService.setCartCloseCallback(vm.closeCart);
            CartService.addCartQuantityUpdateCallback(onCartQuantityUpdated);

            function removeItemsWithNoQuantity(cartItems) {
                for (var i = 0; i < cartItems.length; i++) {
                    if (cartItems[i].quantity === 0) {
                        cartItems.splice(i, 1);
                        i--;
                    }
                }
            }

            function getCartItemRebates() {
                var productIdsToFetchFor = [];
                vm.cartItems.forEach(function (item) {
                    productIdsToFetchFor.push(item.id);
                });
                if (productIdsToFetchFor.length) {
                    RebatesService.getRebatesForProducts(productIdsToFetchFor).then(function (rebates) {
                        vm.cartDetails.totalRebatedAmount = 0;
                        vm.cartItems.forEach(function (item) {
                            if (item.id in rebates) {
                                item.rebates = RebatesService.getHighestRebates(rebates[item.id]);
                                item.rebate_amount = 0;
                                item.rebates.forEach(function (rebate) {
                                    item.rebate_amount += Number(rebate.amount);
                                    if (item.quantity <= rebate.quantity_limit) {
                                        item.rebate_quantity = item.quantity;
                                    } else {
                                        item.rebate_quantity = rebate.quantity_limit;
                                    }
                                    vm.cartDetails.totalRebatedAmount += item.rebate_amount * item.rebate_quantity;
                                })
                                vm.cartDetails.totalRebatedAmount += item.total_additional_discounts;
                            }
                        });
                        vm.cmsContext.totalRebatedAmount = $filter('currency')(vm.cartDetails.totalRebatedAmount);
                        updateCartTotalPrice();
                    });
                } else {
                    vm.cartDetails.totalRebatedAmount = 0;
                    updateCartTotalPrice();
                }
            }

            function updateCartTotalPrice() {
                vm.cartTotalPrice = calculateTotalPrice(vm.cartItems);
            }

            function updateFinalizedCartTotalPrice() {
                vm.finalizedCartTotalPrice = calculateTotalPrice(vm.cartItemsWithRebates);
            }

            function calculateTotalPrice(cartItems) {
                var totalPrice = 0;
                cartItems.forEach(function (item) {
                    var itemSubtotal = item.quantity * item.price;
                    if (item.rebate_quantity) {
                        itemSubtotal -= item.rebate_amount * item.rebate_quantity;
                    }
                    itemSubtotal -= item.total_additional_discounts;
                    totalPrice += itemSubtotal;
                });
                return totalPrice;
            }

            function onCartQuantityUpdated() {
                removeItemsWithNoQuantity(vm.cartItems);
                getCartItemRebates();
            }

            getCartItemRebates();
            CartService.cartFinishInit();

            /**
             * Verifies customer information, and decides whether the customer should be approved or rejected
             */
            function openApplicationForm() {
                vm.closeCart();
                var applicationTriggerSource = 'checkout';
                EnerveeRebateService.openApplicationForm(applicationTriggerSource).then(function (data) {
                    vm.openCart();
                    CartAnalyticsService.reportEventWithProducts('Iterable Cart Info');
                    if (data.reason === EnerveeRebateService.formClosedReasons.FORM_COMPLETE) {
                        if (data.data && data.data.is_valid) {
                            removeValidationBypassCodeCookie();
                            showApprovedView();
                        } else {
                            showRejectedView();
                        }
                    } else if (data.reason === EnerveeRebateService.formClosedReasons.DISMISS &&
                        EnerveeRebateService.hasShippingData) {
                        showRejectedView();
                    } else {
                        vm.switchCartView('total');
                    }
                });
            }

            /**
             * User has been approved. Show cart with best rebates for each product
             */
            function showApprovedView() {
                vm.cartGetBestRebate();
                vm.switchCartView('approved');
            }

            /**
             * User has been rejected. Show cart with no rebates for each product
             */
            function showRejectedView() {
                vm.cartItemsWithRebates = cartItemsWithRebatesRemoved(vm.cartItems);
                updateFinalizedCartTotalPrice();
                vm.switchCartView('rejected');
            }

            /**
             * Convert array of products to map by id
             */
            var mapItemsById = function () {
                var itemsById = {};

                vm.cartItems.forEach(function (cartItem) {
                    var id = (cartItem.id).toString();
                    itemsById[id] = {
                        price: cartItem.price,
                        title: cartItem.title,
                        image: cartItem.image,
                        quantity: cartItem.quantity,
                        total_additional_discounts: cartItem.total_additional_discounts,
                    };
                });

                return itemsById;
            };


            /**
             * Get best rebate for each product
             */
            function cartGetBestRebate() {
                vm.cartItemsWithRebates = [];
                vm.loadingBestRebates = true;

                EnerveeCheckoutService.getBestRebates().then(function (data) {
                    vm.loadingBestRebates = false;
                    vm.cartItemsWithRebates = data;

                    // For compatibility with cart item directive (now expects a list of rebates)
                    RebatesService.addRebatesProperty(vm.cartItemsWithRebates);
                    updateProductsWithRebates();
                }, function (errors) {
                    vm.loadingBestRebates = false;
                    // TODO show that something went wrong try later message
                    vm.cartItemsWithRebates = vm.cartItems;
                    updateMessages(0, 0);
                }).then(function () {
                    updateFinalizedCartTotalPrice();
                });
            }

            /**
             *  Update each product with rebates
             */
            function updateProductsWithRebates() {
                var amount = 0,
                    rebatesCount = 0,
                    itemsById = mapItemsById();

                vm.cartItemsWithRebates.forEach(function (cartItem) {
                    if (cartItem.product_id in itemsById) {
                        angular.extend(cartItem, itemsById[cartItem.product_id]);
                        cartItem.quantity = cartItem.product_quantity;
                        amount += cartItem.total_additional_discounts;
                        if (cartItem.rebate_quantity) {
                            var rebateAmount = parseFloat(cartItem.rebate_amount) * cartItem.rebate_quantity;
                            amount += rebateAmount;
                            rebatesCount += cartItem.rebate_quantity;
                        }
                    }
                });

                updateMessages(rebatesCount, amount);
            }

            /**
             * Based on whether products have rebates or not, or if all products have
             * rebates or only part show different messages
             */
            var updateMessages = function (rebatesCount, amount) {
                // if none of products have eligible rebates
                // show not eligible message
                if (rebatesCount === 0) {
                    vm.switchCartView('norebates');
                }

                CmsContentService.getMarketPlaceText('checkout:approved_subtitle',
                    {'amount': $filter('currency')(amount)}
                ).then(function (text) {
                    vm.eligibleSubtitle = text;
                });

                // if all products eligible for some rebate
                // show full eligibility message
                if (vm.cartDetails.itemCount === rebatesCount) {
                    vm.fullEligibleForRebates = true;
                }
            };


            // Toggles whether the continue button in the "total" view
            // goes to the external Checkout page or cart verification view.
            vm.cartTotalSubmit = function () {
                if (vm.isCheckoutEnabled) {
                    vm.loadingVerification = true;
                    EnerveeCheckoutService.createOrUpdateApplication().then(function (data) {
                        EnerveeRebateService.setValidationData(data);
                        EnerveeRebateService.checkApplicationValid().then(function (validated) {
                            vm.loadingVerification = false;
                            if (validated === true) {
                                showApprovedView();
                            } else {
                                openApplicationForm();
                            }
                        });
                    });
                } else {
                    CartService.checkout();
                }
            };

            /**
             * Redirects the user into the checkout destination site.
             * NOTE: Since the cartId and provider id will need to be sent to the
             * retailer regardless of whether or not the user is approved,
             * this action won't actually differ based on verification approval.
             */
            function redirectToCheckout() {
                vm.redirectingToCheckout = true;
                var utilityId = UtilService.getSetting('utilityId', 0);
                var url = CartService.cartDetails.redirectUrl;
                if (!url) {
                    $log.error("No url has been set with site setting \"checkout_approved_redirect_url\"!");
                    vm.redirectingToCheckout = false;
                    return;
                }

                const shouldSendGa = UtilService.isFeatureEnabled("checkout_send_ga");
                if (shouldSendGa) {
                    url += getGaClientIdParam();
                }

                EnerveeCheckoutService.getCartIdCopy().then(function (cartId) {
                    var formData = {
                        cartId: cartId,
                        utilityId: utilityId
                    };
                    var status = 'Verification Failed'
                    if (vm.cartView.approved == true) {
                        status = 'Verification Succeeded';
                    }
                    CartAnalyticsService.reportEvent('Checkout Started', {
                        location: 'cart',
                        total_price: vm.finalizedCartTotalPrice,
                        status: vm.cartView.approved ? 'Verification Succeeded' : 'Verification Failed'
                    }).then(function () {
                        submitRedirectForm(url, formData);
                    });
                });
            }

            /**
             * Returns the ga client id stored in the ga cookie determined by the checkout_ga_cookie_name setting
             *
             * @returns {string}
             */
            function getGaClientIdParam() {
                const gaCookieName = UtilService.getSiteSetting('checkout_ga_cookie_name', '_ga');
                const gaValue = CookiesService.get(gaCookieName);

                if (gaValue) {
                    const gaClientId = gaValue.substring(6);
                    return "?_ga=" + gaClientId;
                }
                return "";
            }

            /**
             * POSTs approval form data to send user to new page with a POST request
             * @param {String} url the url to submit the data (and send the user) to
             * @param {Object} formData the form data to attach to the request
             * @param {String} formData.cart_id
             * @param {String} formData.utility_id
             */
            function submitRedirectForm(url, formData) {
                if (formData) {
                    vm.redirectFormUrl = $sce.trustAsResourceUrl(url);
                    vm.redirectFormData = formData;
                    $timeout(function () {
                        vm.redirectForm.submit();
                    });
                }
            }

            /**
             * Helper function that removes rebate information from an array of cart
             * items and returns a new array.
             * @param {Object[]} cartItems An array of cart item objects
             */
            function cartItemsWithRebatesRemoved(cartItems) {
                function stripRebateFromItem(item) {
                    item.rebates = [];
                    item.rebate = null;
                    item.rebate_amount = null;
                    item.rebate_id = null;
                    item.rebate_quantity = 0;
                }

                var cartItemsCopy = angular.copy(cartItems);
                cartItemsCopy.forEach(stripRebateFromItem);
                return cartItemsCopy;
            }
        };

        /**
         * Remove claim validation bypass code cookie.
         */
        function removeValidationBypassCodeCookie() {
            CookiesService.remove(constants.CLAIM_VALIDATION_BYPASS_CODE);
        }

    }
})(angular);
